import type {MouseEvent, ReactNode} from "react";

type CardPadding = "none" | "sm" | "md" | "lg";

interface BaseCardProps {
  children: ReactNode;
  padding?: CardPadding;
  className?: string;
  onClick?: (e: MouseEvent<HTMLDivElement>) => void;
}

const paddingStyles: Record<CardPadding, string> = {
  none: "",
  sm: "p-4",
  md: "p-6",
  lg: "p-8",
};

export const BaseCard = ({children, padding = "md", className = "", onClick}: BaseCardProps) => (
  <div
    role={onClick ? "button" : undefined}
    tabIndex={onClick ? 0 : undefined}
    onClick={onClick}
    onKeyDown={onClick ? e => e.key === "Enter" && onClick() : undefined}
    className={[
      "bg-(--color-bg-card) rounded-lg shadow-sm border border-(--color-border)",
      paddingStyles[padding],
      onClick ? "cursor-pointer hover:shadow-md transition-shadow duration-(--transition-fast)" : "",
      className,
    ].join(" ")}
  >
    {children}
  </div>
);
